import React from 'react';
import PropTypes from 'prop-types';
import SidebarPanel from 'components/shared/sidebar/SidebarPanel';
import StyledDesktopDrawer from 'common/theme/drawers/StyledDesktopDrawer';

function DesktopDrawer({ drawerWidth }) {
  return (
    <StyledDesktopDrawer variant="permanent" drawerWidth={drawerWidth} open>
      <SidebarPanel variant="desktop" />
    </StyledDesktopDrawer>
  );
}

DesktopDrawer.propTypes = {
  drawerWidth: PropTypes.number.isRequired
};

export default DesktopDrawer;
